<template>
  <div>
    <loading></loading>
  </div>
</template>

<script>

  import http from "../../services/axios"
  import {GET_BACKEND_URL} from "../../services/constants"

  export default {
      name: 'SurveyPublicLoading',

      created() {
        return http.post(this.$store.getters[GET_BACKEND_URL](`studies/${this.$route.params.study_id}/participants`),{}, {params: this.$route.query} ).then(response => {
          this.$router.push(`/survey/${response.data.uniqueUrl}`)
        }).catch(err => {
          console.error(err)
        })
      }
    }
</script>

<style scoped>

</style>
